"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _CustomPropertyField = _interopRequireDefault(require("./CustomPropertyField"));
var _hooks = require("../../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CustomPropertyFormCard = _ref => {
  let {
    availableCustomProperties,
    customProperty,
    customPropertyType,
    customProperties,
    handleDeleteCustomProperty,
    index,
    internalPropertyCounter,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    name,
    onChange,
    setCustomProperties,
    value
  } = _ref;
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const getHeader = () => {
    if (customPropertyType === 'optional') {
      return kintIntl.formatKintMessage({
        id: 'customProperty.optionalPropertyHeader',
        overrideValue: labelOverrides.optionalPropertyHeader
      }, {
        number: internalPropertyCounter,
        name: customProperty.value
      });
    }
    return kintIntl.formatKintMessage({
      id: 'customProperty.primaryPropertyHeader',
      overrideValue: labelOverrides.primaryPropertyHeader,
      fallbackMessage: customProperty.label
    }, {
      number: internalPropertyCounter,
      name: customProperty.value
    });
  };
  const getTooltipText = () => kintIntl.formatKintMessage({
    id: 'customProperty.remove',
    overrideValue: labelOverrides.remove
  }, {
    number: internalPropertyCounter,
    name: customProperty.value
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Card, {
    "data-testid": "custom-property-form-card",
    headerEnd: customPropertyType === 'optional' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Tooltip, {
      id: `customProperty-${customProperty.value}-${index}`,
      text: getTooltipText(),
      children: _ref2 => {
        let {
          ref,
          ariaIds
        } = _ref2;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.IconButton, {
          ref: ref,
          "aria-labelledby": ariaIds.text,
          icon: "trash",
          id: `edit-customproperty-${index}-delete`,
          onClick: () => handleDeleteCustomProperty(customProperty, index)
        });
      }
    }) : null,
    headerStart: /*#__PURE__*/(0, _jsxRuntime.jsxs)("strong", {
      children: [getHeader(), customProperty.description ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.InfoPopover, {
        content: customProperty.description
      }) : null]
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CustomPropertyField.default, {
      availableCustomProperties,
      customProperty,
      customPropertyType,
      customProperties,
      index,
      internalPropertyCounter,
      intlKey: passedIntlKey,
      intlNS: passedIntlNS,
      labelOverrides,
      name,
      onChange,
      setCustomProperties,
      value
    })
  }, customProperty.value);
};
CustomPropertyFormCard.propTypes = {
  availableCustomProperties: _propTypes.default.arrayOf(_propTypes.default.object),
  customProperty: _propTypes.default.object,
  customPropertyType: _propTypes.default.string,
  customProperties: _propTypes.default.arrayOf(_propTypes.default.object),
  handleDeleteCustomProperty: _propTypes.default.func,
  index: _propTypes.default.number,
  internalPropertyCounter: _propTypes.default.number,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  labelOverrides: _propTypes.default.object,
  name: _propTypes.default.string,
  onChange: _propTypes.default.func,
  setCustomProperties: _propTypes.default.func,
  value: _propTypes.default.object
};
var _default = exports.default = CustomPropertyFormCard;